import { Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../Translations';
import { SchoolPartnerLogo } from '../../../../Common/Experience/SchoolPartner';
import { ProgramSequenceProductDetails } from '../../../../Common/Experience/Types';

interface Props {
  className?: string;
  productDetails: ProgramSequenceProductDetails;
}

function SchoolPartners({ productDetails }: Props) {
  return (
    <div>
      <Typography variant="h5" fontWeight="bold">
        <T kind="School Partner" />
      </Typography>
      <Typography variant="subtitleSmall" className="mt-4">
        <T kind="As part of this learning journey you will complete programs from the following partners." />
      </Typography>
      <div className="mt-8 flex flex-row flex-wrap gap-4 sm:mt-12 lg:gap-12">
        {productDetails.schoolPartnerResources.map((schoolPartnerLogo, index) => {
          return <SchoolPartnerLogo key={index} data={schoolPartnerLogo} height={50} />;
        })}
      </div>
    </div>
  );
}

export default observer(SchoolPartners);
